var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86759 4.63008C3.34947 4.8046 3 5.29459 3 5.84649V9.34829C3 14.9048 6.37552 19.8913 11.5001 21.9052C11.8216 22.0316 12.1784 22.0316 12.4999 21.9052C17.6245 19.8913 21 14.9048 21 9.34829V5.84649C21 5.29459 20.6505 4.80461 20.1324 4.63008L12.6325 2.10372C12.2219 1.96543 11.7781 1.96543 11.3675 2.10372L3.86759 4.63008ZM17.5303 9.50045L11.5303 15.5638C11.2374 15.8597 10.7626 15.8597 10.4697 15.5638L7.46967 12.5321C7.17678 12.2361 7.17678 11.7562 7.46967 11.4603C7.76256 11.1643 8.23744 11.1643 8.53033 11.4603L11 13.956L16.4697 8.4286C16.7626 8.13262 17.2374 8.13262 17.5303 8.4286C17.8232 8.72458 17.8232 9.20447 17.5303 9.50045Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtection);
export default __webpack_public_path__ + "static/media/protection.95d064de473cb2f445751d1b6a69b5ae.svg";
export { ForwardRef as ReactComponent };